const OPERATOR_PATTERN = /([+\-×÷])/;

export function evalCalcExpr(expr: string): number {
  const clean = expr.replace(/[+\-×÷]$/, '');
  if (!clean) return 0;

  const parts = clean.split(OPERATOR_PATTERN);
  let currentTerm = Number(parts[0]);
  if (Number.isNaN(currentTerm)) return NaN;

  const terms: number[] = [];
  const additiveOperators: string[] = [];

  for (let i = 1; i < parts.length; i += 2) {
    const operator = parts[i];
    const operandText = parts[i + 1];
    if (!operandText) return NaN;

    const operand = Number(operandText);
    if (Number.isNaN(operand)) return NaN;

    if (operator === '×') {
      currentTerm *= operand;
    } else if (operator === '÷') {
      if (operand === 0) return NaN;
      currentTerm /= operand;
    } else {
      terms.push(currentTerm);
      additiveOperators.push(operator);
      currentTerm = operand;
    }
  }

  terms.push(currentTerm);
  const result = additiveOperators.reduce((total, operator, index) => {
    return operator === '+' ? total + terms[index + 1] : total - terms[index + 1];
  }, terms[0]);

  return Math.round(result * 100) / 100;
}

export function hasCalcOperator(expr: string): boolean {
  return /\d[+\-×÷]/.test(expr);
}
